import React from 'react';
import { Controller, type Control } from 'react-hook-form';
import { Checkbox, Link } from '@planne-software/uni';

import { useTranslate } from '@src/core/hooks';

import { authLinkSx } from '@src/features/customers/auth/styles';
import { FieldErrorText, TermsStack, TermsCheckboxSlot, TermsRow, TermsText } from '../../styles';
import type { SignupFormValues } from '../../hooks/useSignupForm/signupSchema';
import { TermsDocumentModal } from './TermsDocumentModal';
import { useTermsAcceptance } from './useTermsAcceptance';

type TermsAcceptanceProps = {
  control: Control<SignupFormValues>;
  disabled?: boolean;
};

export const TermsAcceptance = (props: TermsAcceptanceProps) => {
  const { control, disabled } = props;
  const { i18n } = useTranslate();
  const { openTerms, openTermsOfUse, openPrivacyPolicy, closeTerms } = useTermsAcceptance();

  return (
    <>
      <Controller
        name='agreesToTerms'
        control={control}
        render={({ field: { onChange, value }, fieldState }) => (
          <TermsStack>
            <TermsRow data-testid='signup-terms'>
              <TermsCheckboxSlot>
                <Checkbox
                  name='agreesToTerms'
                  id='agreesToTerms'
                  checked={Boolean(value)}
                  disabled={disabled}
                  error={!!fieldState.error}
                  onChange={(_event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => onChange(checked)}
                />
              </TermsCheckboxSlot>
              <TermsText>
                {i18n('checkout_auth_signup_terms_prefix')}{' '}
                <Link component='button' type='button' underline='always' sx={authLinkSx} onClick={openTermsOfUse}>
                  {i18n('checkout_auth_signup_terms_of_use')}
                </Link>{' '}
                {i18n('checkout_auth_signup_terms_connector')}{' '}
                <Link component='button' type='button' underline='always' sx={authLinkSx} onClick={openPrivacyPolicy}>
                  {i18n('checkout_auth_signup_privacy_policy')}
                </Link>
              </TermsText>
            </TermsRow>

            {fieldState.error ? <FieldErrorText>{fieldState.error.message}</FieldErrorText> : null}
          </TermsStack>
        )}
      />

      {openTerms ? <TermsDocumentModal type={openTerms} onClose={closeTerms} /> : null}
    </>
  );
};

export default TermsAcceptance;
